import Alert from '@mui/material/Alert';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import type { DailyLoss } from '../../api';

import { WarningNotice } from './WarningNotice';

/**
 * Approaching the limit is announced politely (`WarningNotice`); reaching it keeps the Alert
 * role (assertive).
 *
 * Warning at half the maximum daily loss, and the rule once it is reached (FXM-02 §4; M1 R9,
 * R10). Q1: follows the FXM-02 §4 body (openings refused, closes continue), not the glossary's
 * "stops all copying".
 */
export function DailyLimitAlert({
  dailyLoss,
}: {
  readonly dailyLoss: DailyLoss | null;
}): ReactElement | null {
  const { t } = useTranslation();
  const state = dailyLoss?.limit?.state;
  if (state === 'approached') {
    return <WarningNotice>{t('home.dailyLoss.approached')}</WarningNotice>;
  }
  if (state === 'reached') {
    return (
      <Alert
        severity="error"
        sx={(theme) => ({ bgcolor: theme.fx.dangerBg, color: theme.fx.text })}
      >
        {t('home.dailyLoss.reached')}
      </Alert>
    );
  }
  return null;
}
